

export function getOperationColor(operationType: string): string {
    switch (operationType) {
        case 'Adjustments': return '#ffa500';
        case 'Offset': return '#1e90ff';
        case 'Tool change': return '#ff4500';
        case 'Program edit': return '#9370db';
        case 'Fix unscheduled tool change': return '#32cd32';
        case 'Measurement': return '#008080';
        case 'Scrap': return '#2c3e50';
        default: throw new Error(`Unknown operation type: ${operationType}`);
    }
}
